export default __webpack_public_path__ + "static/blob3-e45e10c218b68e99971401ee333ff4e8.svg";